
import axios from 'axios'


function getAlarm(pointId, id) {
    return axios.get(`${process.env.VUE_APP_APIURL}/point/${pointId}/alarm/${id}`).then(res => {
        return res.data
    })
}

function getAlarms(pointId) {
    return axios.get(`${process.env.VUE_APP_APIURL}/point/${pointId}/alarm`).then(res => {
        return res.data
    })
}

function createAlarm(pointId, alarm) {
    return axios.post(`${process.env.VUE_APP_APIURL}/point/${pointId}/alarm`, alarm).then(res => {
        return res.data
    })
}

function updateAlarm(pointId, alarm) {
    return axios.put(`${process.env.VUE_APP_APIURL}/point/${pointId}/alarm/${alarm._id}`, alarm).then(res => {
        return res.data
    })
}

function deleteAlarm(pointId, alarmId) {
    return axios.delete(`${process.env.VUE_APP_APIURL}/point/${pointId}/alarm/${alarmId}`).then(res => {
        return res.data
    })
}

export default {
    getAlarm,
    getAlarms,
    createAlarm,
    updateAlarm,
    deleteAlarm,
};